import { ComponentProps } from "react";
import Card from "@particles/card/Card";
import CardGroupedListItem from "@particles/card/components/CardGroupedList/CardGroupedListItem";
import HomePageTopStories from "@routes/Home/Overview/HomepageTopStories";
import { cn } from "@util/helpers";

export type HomepageTopOverviewProps = {
  /** Additionl styling for the component */
  className?: string;
  /** The list of the article card props */
  cardProps: ComponentProps<typeof Card>[];
  /** The list of the grouped article card props */
  groupedCardProps?: ComponentProps<typeof CardGroupedListItem>[];
};

/**
 * Renders the Home - top stories section with a list of articles.
 */
const HomepageTopOverview = ({
  className,
  cardProps,
  groupedCardProps,
}: HomepageTopOverviewProps): React.ReactElement => {
  return (
    <section
      data-testid="homepage-top-stories-component"
      className={cn(
        "stories flex list-none flex-col",
        "lg:grid lg:grid-flow-col lg:grid-cols-3 lg:grid-rows-4",
        className
      )}
    >
      {cardProps.map((card, index) => {
        return (
          <HomePageTopStories
            groupedCardProps={groupedCardProps}
            cardProps={card}
            index={index}
            key={card.id}
          />
        );
      })}
    </section>
  );
};

export default HomepageTopOverview;
